module.exports = __webpack_public_path__ + "img/sd.1955fda1.svg";